import { MenuItem, Portal, Select } from '@mui/material';
import React, { useState } from 'react';
import { edit_sample_receiver_schedule } from '../utilis/sampleReceiverServices';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';

const CustomReceiverDropdown = (params) => {
  const { value, row, id, field, api, ...otherProps } = params;
  console.log(value);
  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });
  const handleChange = async (e) => {
    try {
      const newValue = e?.target?.value;
      console.log({ newValue, id, field, row });

      const material_type = (() => {
        switch (row.sample_type) {
          case "SFG(without micro)":
            return "INTM";
          case "SFG(with micro)":
            return "INTM";
          case "FP(without micro)":
            return "FP";
          case "FP(with micro)":
            return "FP";
          case "CB(urgent)":
            return "CB";
          case "CB(additional)":
            return "CB";
          case "CB":
            return "CB";
          default:
            return row.sample_type;
        }
      })();

      // const updatedRow = {
      //   ...row,
      //   storage_condition: newValue,
      // };

      const updatedRow = {
        ...row,
        [field]: newValue,
      };

      const res = await edit_sample_receiver_schedule(updatedRow, material_type, set_open_snackbar_with_message);

      if (res) {
        api.updateRows([{
          id,
          [field]: newValue
        }]);
      }
    } catch (error) {
      console.log(error);
      set_open_snackbar_with_message({
        message: error?.response?.data?.error,
        open: true,
        severity: "error"
      });
    }

  };
  return (
    <div className='w-full'>
      <Portal>
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
      </Portal>
      <Select fullWidth value={value} onChange={handleChange} >
        <MenuItem value={"Between 2 to 8 degree C"} >Between 2 to 8 degree C</MenuItem>
        <MenuItem value={"Store below 25 degree C"} >Store below 25 degree C</MenuItem>
      </Select>
    </div>
  );
};

export default CustomReceiverDropdown;